export default __webpack_public_path__ + "static/media/yellow-cards.9d2a56c0.png";